<template>
  <div
    v-loading="upgradeContinueIsLoading || !currencyCode"
    :element-loading-text="loadingText"
    class="flex justify-center h-full py-15 px-20 mobile-l:py-20 mobile-l:px-25 tablet:py-25 tablet:px-35"
  >
    <Transition
      name="fade-medium"
      mode="out-in"
    >
      <PackageOptions
        v-if="currencyCode"
        type="subscription-plans"
        :packages="packagesSubscriptionPlans"
        :currency-code="currencyCode"
        @continue="onContinuePress($event)"
      >
        <span class="font-medium text-lg tracking-wide">
          Subscribe now
        </span>
      </PackageOptions>
    </Transition>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { APIAddSubscription } from '@/api';
import loadExternalScript from '@/utils/loadExternalScript';
import { defaultCurrencyCode } from '@/utils/intl';
import { showErrorNotification } from '@/utils/notification';
import PackageOptions from '@/components/PackageOptions';

export default {
  components: {
    PackageOptions,
  },
  data: () => ({
    stripeRef: null,
    currencyCode: '',
    upgradeContinueIsLoading: false,
  }),
  mounted() {
    loadExternalScript('https://js.stripe.com/v3/')
      .then(() => {
        const { Stripe } = window;

        this.stripeRef = Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  watch: {
    userIsLoading: {
      immediate: true,
      handler(newValue) {
        if (newValue) return;

        // A currency already on the profile wins: their earlier payments were made in it
        this.$store.dispatch('currency/resolve', this.userDetails.currencyCode)
          .then((currencyCode) => {
            this.currencyCode = currencyCode || defaultCurrencyCode;
          });
      },
    },
  },
  computed: {
    ...mapState('user', {
      userIsLoading: 'isLoading',
      userDetails: 'details',
    }),
    ...mapGetters('packages', {
      packagesSubscriptionPlans: 'subscriptionPlans',
    }),
    loadingText() {
      if (!this.currencyCode) return 'Getting the latest packages..';

      return 'Redirecting you to the payment..';
    },
  },
  methods: {
    onContinuePress({ packageId, currencyCode }) {
      this.upgradeContinueIsLoading = true;

      APIAddSubscription({
        packageId,
        stripeCheckout: {
          currencyCode,
          successUrl: `http://${window.location.host}/dashboard`,
          cancelUrl: window.location.href,
        },
      }).then((result) => {
        this.stripeRef.redirectToCheckout({
          sessionId: result.data.stripeSessionId,
        }).then((redirectResult) => {
          // If `redirectToCheckout` fails due to a browser or network
          // error, display the localized error message to your customer
          // using `result.error.message`.
          if (redirectResult.error.message) {
            this.upgradeContinueIsLoading = false;
            console.error(redirectResult.error);
            showErrorNotification(redirectResult.error.message);
          }
        });
      }).catch((error) => {
        this.upgradeContinueIsLoading = false;
        console.error(error?.response?.data?.message || error?.message);
        showErrorNotification(error?.response?.data?.message || error?.message);
      });
    },
  },
};
</script>

<style scoped>
</style>
